import { fetchAPI } from "./api";

/**
 * Gets the member OBP token for booking links
 * @param {string} service - The service endpoint for the booking
 * @returns {Promise} - Returns the API response with booking data
 */
export const getMemberOBPToken = async (service) => {
  const initMemberID =
    typeof window !== "undefined" &&
    (window.localStorage.getItem("offbeat-member-id") ||
      window.localStorage.getItem("ob-init-member-id"));

  if (!initMemberID) {
    throw new Error("Initial member ID not found");
  }

  const res = await fetchAPI(
    `/GetMemberOBPToken?MemberID=${initMemberID}&returnurl=${service}`,
    "GET",
    null,
    null,
  );

  return res;
};

/**
 * Opens a booking link in a new tab
 * @param {string} service - The service endpoint for the booking
 * @param {Function} setOpen - Function to open login modal if user not authenticated
 */
export const openOBBookingLink = async (service, setOpen) => {
  if (
    typeof window !== "undefined" &&
    (window.localStorage.getItem("offbeat-member-id") ||
      window.localStorage.getItem("ob-init-member-id"))
  ) {
    try {
      const res = await getMemberOBPToken(service);
      window.open(res?.Data, "_blank");
    } catch (error) {
      console.error("Error getting OB booking link:", error);
      if (setOpen) setOpen(true);
    }
  } else {
    if (setOpen) setOpen(true);
  }
};

/**
 * Opens the SA Resorts SSO link in a new tab using stored member credentials
 * @param {Function} setOpen - Function to open login modal if user not authenticated
 */
export const openSAResortsSSO = (setOpen) => {
  const userName =
    typeof window !== "undefined" &&
    window.localStorage.getItem("offbeat-sso-username");
  const accessToken =
    typeof window !== "undefined" &&
    window.localStorage.getItem("offbeat-sso-access-token");

  if (userName && accessToken) {
    window.open(
      `https://saresorts.offbeat.co.za/Auth/sso?username=${encodeURIComponent(userName)}&accessToken=${encodeURIComponent(accessToken)}`,
      "_blank"
    );
  } else {
    if (setOpen) setOpen(true);
  }
};

/**
 * Checks if user has initial member ID (is logged in with initial auth)
 * @returns {boolean} - Returns true if user has ob-init-member-id
 */
export const hasInitialMemberID = () => {
  return (
    typeof window !== "undefined" &&
    Boolean(window.localStorage.getItem("ob-init-member-id"))
  );
};
